export function isDelayShowIntentSelector(displayType: number) {
  return displayType === 1 || displayType === 3;
}
